export var LOGGER_NAME = 'whatfix';
export var WHATFIX_URL = {
    // Admin URL will be same for all envs ie., integration, staging and prod
    ADMIN: 'https://cdn.whatfix.com/prod/08924877-5b83-49e9-9aa1-fe3ff40203c3/initiator/initiator.nocache.js',
    // Learner URL will be same for all envs ie., integration, staging and prod
    LEARNER: 'https://cdn.whatfix.com/prod/c5f27ff0-c771-4908-b1be-c159239736c2/initiator/initiator.nocache.js',
};
//# sourceMappingURL=constants.js.map